export const consumerRoutes = {
  getAllConsumers: () => '/consumers',
  aboutConsumerById: (consumerId: string) => `/consumers/${consumerId}`,
  unlockConsumerById: (consumerId: string) => `/consumers/${consumerId}/unlock`,
  lockConsumerById: (consumerId: string) => `/consumers/${consumerId}/lock`,
  consumerMessages: (consumerId: string) => `/consumers/${consumerId}/messages`,
  consumerOperation: (consumerId: string) => `/consumers/${consumerId}/operations`,
  consumerBalance: (consumerId: string) => `/consumers/${consumerId}/balance`,
  consumerTokens: (consumerId: string) => `/consumers/${consumerId}/tokens`,
  consumerReferrals: (consumerId: string) => `/consumers/${consumerId}/referrals`,
  consumerIntegrations: (consumerId: string) => `/consumers/${consumerId}/integrations`,
  resetConsumer2FAById: (consumerId: string) => `/consumers/${consumerId}/reset2fa`,
  getLogsByConsumerId: (consumerId: string) => `/consumers/${consumerId}/logs`,
  consumersExport: () => '/consumers/export',
  consumersSettings: () => '/consumers/settings',
  consumersSettingsById: (settingsId: string) => `/consumers/settings/${settingsId}`,
  getConsumerMagicLink: (consumerId: string) => `/consumers/${consumerId}/magic`,
  consumersLanguages: () => '/consumers/languages',
  consumersLanguageById: (languageId: string) => `/consumers/languages/${languageId}`,
  deleteConsumersLanguage: (languageId: string) => `/consumers/languages/${languageId}/delete`,
  restoreConsumersLanguage: (languageId: string) => `/consumers/languages/${languageId}/restore`,
};
